module.exports = __webpack_public_path__ + "img/client-3--small.png?46dd714d4ada5429f326643f2c2b7553";